export default __webpack_public_path__ + "static/media/BackdropCircles.b712c634.svg";